import vmList from './popup-fun/vm-list';

export default function () {
  for (let item in vmList) {
    vmList[item].show = false;
    setTimeout(() => {
      document.getElementsByClassName('v-model')[0] && document.body.removeChild(document.getElementsByClassName('v-model')[0]);
    }, 1000);
    document.querySelector('#app').removeChild(vmList[item].$el);
    vmList[item].$destroy();
    delete vmList[item];
  }
}



// WEBPACK FOOTER //
// ./src/utils/destory-popup.js